import axios, { InternalAxiosRequestConfig } from 'axios';

// Crear una instancia de Axios
const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Configurar el interceptor de solicitudes
axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;